<template>
<div class="chapter">
<div class="inner_page">
<div class="frame">
<img alt="feathered%20star2.psd" class="frame1" src="OEBPS/image/feathered_star2_fmt.png"/>
</div>
<div class="basic-text-frame">
<p class="bodytext3"><span class="dedication1">Feathered Star block</span></p>
</div>
<div class="basic-text-frame">
<p class="bodytext"><span class="testimonial-body"></span></p>
<p class="bodytext1"><span class="testimonial-body"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lily_Girl_split3.vue?951ead8c